import { render } from "./Entidades.vue?vue&type=template&id=1bb94b97&scoped=true"
import script from "./Entidades.vue?vue&type=script&lang=js"
export * from "./Entidades.vue?vue&type=script&lang=js"

import "./Entidades.vue?vue&type=style&index=0&id=1bb94b97&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb94b97"]])

export default __exports__